import { Link } from "react-router-dom";
import type { AnimeResource } from "@/mocks/resources";

export default function ResourceCard({ resource }: { resource: AnimeResource }) {
  return (
    <article className="group bg-background-50 border border-background-200 rounded-2xl overflow-hidden hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 flex flex-col">
      <Link to={`/library/${resource.id}`} className="relative block aspect-[3/4] overflow-hidden">
        <img
          src={resource.cover}
          alt={`${resource.title} 全集资源封面`}
          title={`${resource.title} 全集资源`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/75 text-background-50 text-xs whitespace-nowrap">
          {resource.category}
        </span>
        {resource.status === "连载中" && (
          <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs whitespace-nowrap">
            更新中
          </span>
        )}
      </Link>
      <div className="p-4 flex flex-col gap-2 flex-1">
        <h3 className="font-heading text-base text-foreground-950 leading-snug line-clamp-1">
          <Link to={`/library/${resource.id}`} className="hover:text-primary-600 transition-colors">
            {resource.title}
          </Link>
        </h3>
        <p className="text-xs text-foreground-600 leading-5 line-clamp-2">{resource.summary}</p>
        <div className="mt-auto pt-2 flex items-center justify-between text-xs text-foreground-700">
          <span className="whitespace-nowrap">{resource.episodes}</span>
          <span className="flex items-center gap-1 font-medium text-primary-700 whitespace-nowrap">
            <i className="ri-star-fill text-primary-500" aria-hidden="true"></i>
            {resource.rating}
          </span>
        </div>
      </div>
    </article>
  );
}